<template>
    <app-layout>
        <template #header>

        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">

                <JetNavLink :href="route('dashboard')" :active="route().current('user')" class="mb-5">Back</JetNavLink>
                <div v-if="!editMode">
                    <p><b>Name: </b>{{ userdetail.firstName + ' ' + userdetail.lastName }}</p>
                    <p><b>Email: </b>{{ userdetail.email }}</p>
                    <p><b>Role: </b>{{ userdetail.role }}</p>
                    <p><b>Is Admin: </b>{{ userdetail.is_admin ? 'Yes' : 'No' }}</p>
                    <p v-if="userdetail.country"><b>Country: </b>{{ userdetail.country }}</p>
                    <p v-if="userdetail.company"><b>Company: </b>{{ userdetail.company }}</p>
                    <p v-if="userdetail.aff_with"><b>Working with: </b>{{ userdetail.aff_with }}</p>
                    <p v-if="userdetail.aff_with"><b>Relationship: </b>{{ userdetail.rel_with }}</p>
                    <p v-if="userdetail.access_image_gallery"><b>Access Image Gallery: </b>{{ userdetail.access_image_gallery ? 'Yes' : 'No' }}</p>
                    <p><b>Account Status: </b><span :class="statusClass">{{ status }}</span></p>
                    <p v-if="status==='Rejected'"><b>Reason for rejection: </b><span :class="statusClass">{{ userdetail.rejected_reason }}</span></p>
                    <p><b>Approval Date: </b>{{ userdetail.approved_at }}</p>
                    <p><b>Last login: </b>{{ userdetail.last_login }}</p>
                </div>
                <form ref="form" v-if="editMode" v-on:submit.prevent="toggleEdit">
                    <div class="mt-1 md:flex md:items-center">
                        <div class="mb-1 md:mb-0 md:w-1/5 font-bold">
                            <label for="email">Email</label>
                        </div>
                        <div class="md:w-4/5 md:flex-grow">{{ userdetail.email }}</div>
                    </div>
                    <div class="mt-1 md:flex md:items-center">
                        <div class="mb-1 md:mb-0 md:w-1/5 font-bold">
                            <label for="firstName">First Name</label>
                        </div>
                        <div class="md:w-4/5 md:flex-grow">
                            <input class="w-full h-10 px-3 text-base placeholder-gray-600 border rounded-lg focus:shadow-outline" type="text" id="firstName" v-model="userdetail.firstName" required autocomplete="off"/>
                        </div>
                    </div>
                    <div class="mt-1 md:flex md:items-center">
                        <div class="mb-1 md:mb-0 md:w-1/5 font-bold">
                            <label for="lastName">Last Name</label>
                        </div>
                        <div class="md:w-4/5 md:flex-grow">
                            <input class="w-full h-10 px-3 text-base placeholder-gray-600 border rounded-lg focus:shadow-outline" type="text" id="lastName" v-model="userdetail.lastName" required autocomplete="off"/>
                        </div>
                    </div>
                    <div class="mt-1 md:flex md:items-center">
                        <div class="mb-1 md:mb-0 md:w-1/5 font-bold">
                            <label for="role">Role</label>
                        </div>
                        <div class="md:w-4/5 md:flex-grow">
                            <select class="w-full h-10 px-3 text-base placeholder-gray-600 border rounded-lg focus:shadow-outline" id="role" v-model="userdetail.role" required>
                                <option disabled value="">Please select one</option>
                                <option value="TMA">TMA</option>
                                <option value="Distributor">Distributor</option>
                                <option value="Dealer">Dealer</option>
                                <option value="Agency">Agency</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="userdetail.role == 'Dealer' || userdetail.role == 'Agency'" class="mt-1 md:flex md:items-center">
                        <div class="mb-1 md:mb-0 md:w-1/5 font-bold">
                            <label for="company">Company</label>
                        </div>
                        <div class="md:w-4/5 md:flex-grow">
                            <input class="w-full h-10 px-3 text-base placeholder-gray-600 border rounded-lg focus:shadow-outline" type="text" id="company" v-model="userdetail.company" required autocomplete="off"/>
                        </div>
                    </div>
                    <div v-if="userdetail.role == 'Distributor'" class="mt-1 md:flex md:items-center">
                        <div class="mb-1 md:mb-0 md:w-1/5 font-bold">
                            <label for="country">Country</label>
                        </div>
                        <div class="md:w-4/5 md:flex-grow">
                            <select class="w-full h-10 px-3 text-base placeholder-gray-600 border rounded-lg focus:shadow-outline" id="country" v-model="userdetail.country" required>
                                <option value="" disabled selected>Select country</option>
                                <option value="Bangladesh">Bangladesh</option>
                                <option value="Bhutan">Bhutan</option>
                                <option value="Brunei">Brunei</option>
                                <option value="Cambodia">Cambodia</option>
                                <option value="India">India</option>
                                <option value="Indonesia">Indonesia</option>
                                <option value="Laos">Laos</option>
                                <option value="Malaysia">Malaysia</option>
                                <option value="Myanmar">Myanmar</option>
                                <option value="Nepal">Nepal</option>
                                <option value="Pakistan">Pakistan</option>
                                <option value="Philippines">Philippines</option>
                                <option value="Singapore">Singapore</option>
                                <option value="Sri Lanka">Sri Lanka</option>
                                <option value="Thailand">Thailand</option>
                                <option value="Vietnam">Vietnam</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="userdetail.role == 'Dealer' || userdetail.role == 'Agency'" class="mt-1 md:flex md:items-center">
                        <div class="mb-1 md:mb-0 md:w-1/5 font-bold">
                            <label for="aff_with">Working with</label>
                        </div>
                        <div class="md:w-4/5 md:flex-grow">
                            <select class="w-full h-10 px-3 text-base placeholder-gray-600 border rounded-lg focus:shadow-outline" id="aff_with" v-model="userdetail.aff_with" required>
                                <option value="" disabled selected>Select distributor</option>
                                <option v-if="userdetail.role == 'Agency'" value="TMA">TMA</option>
                                <option value="Bangladesh">Bangladesh</option>
                                <option value="Bhutan">Bhutan</option>
                                <option value="Brunei">Brunei</option>
                                <option value="Cambodia">Cambodia</option>
                                <option value="India">India</option>
                                <option value="Indonesia">Indonesia</option>
                                <option value="Laos">Laos</option>
                                <option value="Malaysia">Malaysia</option>
                                <option value="Myanmar">Myanmar</option>
                                <option value="Nepal">Nepal</option>
                                <option value="Pakistan">Pakistan</option>
                                <option value="Philippines">Philippines</option>
                                <option value="Singapore">Singapore</option>
                                <option value="Sri Lanka">Sri Lanka</option>
                                <option value="Thailand">Thailand</option>
                                <option value="Vietnam">Vietnam</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="userdetail.role == 'Dealer' || userdetail.role == 'Agency'" class="mt-1 md:flex md:items-center">
                        <div class="mb-1 md:mb-0 md:w-1/5 font-bold">
                            <label for="aff_with">Relationship</label>
                        </div>
                        <div class="md:w-4/5 md:flex-grow">
                            <input class="w-full h-10 px-3 text-base placeholder-gray-600 border rounded-lg focus:shadow-outline" type="text" id="rel_with" v-model="userdetail.rel_with" required autocomplete="off"/>
                        </div>
                    </div>
                    <div class="mt-1 md:flex md:items-center">
                        <div class="mb-1 md:mb-0 md:w-1/5 font-bold">
                            <label for="access_image_gallery">Access Image Gallery</label>
                        </div>
                        <div class="md:w-4/5 md:flex-grow">
                            <select class="w-full h-10 px-3 text-base placeholder-gray-600 border rounded-lg focus:shadow-outline" id="access_image_gallery" v-model="userdetail.access_image_gallery" required>
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                        </div>
                    </div>
                    <button v-if="editMode" class="mt-8 bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded modal-button" @click="toggleEdit()">
                        Save
                    </button>
                </form>
                <div class="action-btns mt-8" v-show="!editMode && this.status == 'Pending'">
                    <button class="bg-green-500 hover:bg-green-700 text-white font-bold mr-3 py-2 px-4 rounded" @click="toggleModal('approve')">
                        Approve
                    </button>
                    <button class="bg-red-500 hover:bg-red-700 text-white font-bold mr-3 py-2 px-4 rounded" @click="toggleModal('reject')">
                        Reject
                    </button>
                    <button class="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded modal-button" @click="toggleEdit()">
                        Edit
                    </button>
                </div>
                <div v-show="!editMode && this.status != 'Pending'">
                    <div class="delete-btns mt-8">
                        <button v-if="!userdetail.is_admin" class="bg-green-500 hover:bg-green-700 text-white font-bold mr-3 py-2 px-4 rounded" @click="toggleModal('makeadmin')">
                            Make Admin
                        </button>
                        <button class="bg-red-500 hover:bg-red-700 text-white font-bold mr-3 py-2 px-4 rounded modal-button" @click="toggleModal('delete')">
                            Delete
                        </button>
                        <button v-if="userdetail.is_locked" class="bg-yellow-500 hover:bg-yellow-700 text-white font-bold mr-3 py-2 px-4 rounded" @click="toggleModal('unlock')">
                            Unlock Account
                        </button>
                        <button v-if="!userdetail.is_locked" class="bg-pink-500 hover:bg-pink-700 text-white font-bold mr-3 py-2 px-4 rounded" @click="toggleModal('lock')">
                            Lock Account
                        </button>
                        <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded modal-button" @click="toggleEdit()">
                            Edit
                        </button>
                    </div>
                </div>
                <!-- Confirmation Modal -->
                <jet-dialog-modal :show="confirmingUser" @close="toggleModal()">
                    <template #content>
                        {{ contentMsg }}
                        <div class="user-info" v-if="this.action == 'reject'">
                            <label for="rejectReason" class="pr-4">Reason for rejection</label>
                            <select v-model="rejectReason" name="rejectReason" id="rejectReason" class="rounded border-gray-300">
                                <option value="" disabled selected>Select Reason</option>
                                <option value="Corporate email required for registration">Corporate email required for registration</option>
                                <option value="Unauthorised agency/user">Unauthorised agency/user</option>
                                <option value="Wrong company type selected">Wrong company type selected</option>
                            </select>
                        </div>
                    </template>

                    <template #footer>
                        <jet-secondary-button @click="toggleModal()">
                            Cancel
                        </jet-secondary-button>

                        <jet-danger-button class="ml-2" @click="userAction" :class="{ 'opacity-25': submittingUser }" :disabled="submittingUser">
                            {{ actionBtn }}
                        </jet-danger-button>
                    </template>
                </jet-dialog-modal>
            </div>
        </div>
    </app-layout>
</template>
<style>
    .modal {
        transition: opacity 0.25s ease;
    }
</style>
<script>
    import AppLayout from '@/Layouts/AppLayout'
    import JetActionSection from '@/Jetstream/ActionSection'
    import JetDialogModal from '@/Jetstream/DialogModal'
    import JetDangerButton from '@/Jetstream/DangerButton'
    import JetInput from '@/Jetstream/Input'
    import JetInputError from '@/Jetstream/InputError'
    import JetNavLink from '@/Jetstream/NavLink'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton'


    export default {
        props: [
            'userdetail'
        ],
        components: {
            AppLayout,
            JetActionSection,
            JetDangerButton,
            JetDialogModal,
            JetInput,
            JetInputError,
            JetNavLink,
            JetSecondaryButton,
        },
        data() {
            return {
                editMode: false,
                confirmingUser: false,
                action: '',
                submittingUser: false,
                rejectReason: '',
            }
        },
        computed: {
            status() {
                if (this.userdetail.is_approved === true) {
                    if (this.userdetail.is_locked) {
                        return 'Locked';
                    } else {
                        return 'Active';
                    }
                } else if (this.userdetail.is_approved === false) {
                    return 'Rejected';
                } else if (this.userdetail.is_approved === null) {
                    return 'Pending';
                } else {
                    return 'Unknown';
                }
            },
            statusClass() {
                if (this.userdetail.is_approved === true) {
                    if (this.userdetail.is_locked) {
                        return 'text-yellow-600';
                    } else {
                        return 'text-green-600';
                    }
                } else if (this.userdetail.is_approved === false) {
                    return 'text-red-600';
                } else if (this.userdetail.is_approved === null) {
                    return 'text-blue-600';
                } else {
                    return 'text-gray-600';
                }
            },
            contentMsg() {
                if (this.action == 'approve') {
                    return 'Approve this user?';
                } else if (this.action == 'delete') {
                    return 'Delete this user?';
                } else if (this.action == 'makeadmin') {
                    return 'Make this user admin?';
                } else if (this.action == 'save') {
                    return 'Update this user details?';
                } else if (this.action == 'unlock') {
                    return 'Unlock this user account?';
                } else if (this.action == 'lock') {
                    return 'Lock this user account?';
                }
            },
            actionBtn() {
                if (this.action == 'approve') {
                    return 'Approve Account';
                } else if (this.action == 'reject') {
                    return 'Reject Account';
                } else if (this.action == 'delete') {
                    return 'Delete Account';
                } else if (this.action == 'makeadmin') {
                    return 'Make Admin Account';
                } else if (this.action == 'save') {
                    return 'Save Details';
                } else if (this.action == 'unlock') {
                    return 'Unlock Account';
                } else if (this.action == 'lock') {
                    return 'Lock User Account';
                }
            }
        },
        methods: {
            toggleEdit() {
                if (this.editMode) {
                    if (this.$refs.form.checkValidity()) {
                        this.toggleModal('save');
                    }
                } else {
                    this.editMode = !this.editMode;
                }
            },
            toggleModal(action) {
                this.action = action;
                if (action) {
                    this.confirmingUser = true;
                } else {
                    this.confirmingUser = false;
                }
            },
            userAction() {
                if (this.action == 'approve') {
                    this.approveUser();
                } else if (this.action == 'reject') {
                    this.rejectUser();
                } else if (this.action == 'delete') {
                    this.deleteUser();
                } else if (this.action == 'makeadmin') {
                    this.adminUser();
                } else if (this.action == 'save') {
                    this.editUser();
                } else if (this.action == 'unlock') {
                    this.unlockUser();
                } else if (this.action == 'lock') {
                    this.lockUser();
                }
            },
            editUser() {
                var _this = this;
                axios.put('/api/users/'+this.userdetail.id+'/edit', {
                        action: 'save',
                        firstName: this.userdetail.firstName,
                        lastName: this.userdetail.lastName,
                        role: this.userdetail.role,
                        country: this.userdetail.country,
                        company: this.userdetail.company,
                        aff_with: this.userdetail.aff_with,
                        rel_with: this.userdetail.rel_with,
                        access_image_gallery: this.userdetail.access_image_gallery
                    })
                    .then((res) => {
                        window.location.reload();
                    })
                    .catch(function (error) {
                        window.location.reload();
                    });
            },
            adminUser() {
                var _this = this;
                axios.put('/api/users/'+this.userdetail.id, {action: 'makeadmin'})
                    .then((res) => {
                        _this.toggleModal();
                        window.location.reload();
                    })
                    .catch(function (error) {
                        window.location.reload();
                    });
            },
            lockUser() {
                var _this = this;
                axios.put('/api/users/'+this.userdetail.id, {action: 'lockuser'})
                    .then((res) => {
                        _this.toggleModal();
                        window.location.reload();
                    })
                    .catch(function (error) {
                        window.location.reload();
                    });
            },
            unlockUser() {
                var _this = this;
                axios.put('/api/users/'+this.userdetail.id, {action: 'unlockuser'})
                    .then((res) => {
                        _this.toggleModal();
                        window.location.reload();
                    })
                    .catch(function (error) {
                        window.location.reload();
                    });
            },
            approveUser() {
                var _this = this;
                axios.put('/api/users/'+this.userdetail.id, {action: 'approve'})
                    .then((res) => {
                        _this.toggleModal();
                        _this.$inertia.reload({preserveState: false, replace: true});
                    })
                    .catch(function (error) {
                        window.location.reload();
                    });
            },
            rejectUser() {
                var _this = this;
                axios.put('/api/users/'+this.userdetail.id, {action: 'reject', rejected_reason: this.rejectReason})
                    .then((res) => {
                        _this.toggleModal();
                        _this.$inertia.reload({preserveState: false, replace: true});
                    })
                    .catch(function (error) {
                        window.location.reload();
                    });
            },
            deleteUser() {
                var _this = this;
                axios.delete('/api/users/'+this.userdetail.id)
                    .then((res) => {
                        _this.toggleModal();
                        _this.$inertia.get('/users');
                    })
                    .catch(function (error) {
                        window.location.reload();
                    });
            }
        },
        mounted() {
            axios.get('/api/refresh-csrf-cookie')
                .then(res => {
                    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = res.data.token;
                    document.head.querySelector('meta[name="csrf-token"]').setAttribute("content", res.data.token);
                });
        },
    }

</script>
